import axios from 'axios';

export const authApi = axios.create({
  baseURL: process.env.REACT_APP_SERVICES_KEY_CLOCK,
  withCredentials: true,
});
